module.exports = __webpack_public_path__ + "img/team.2eb6d2c8.jpg";